module.exports = __webpack_public_path__ + "static/img/search.2b29c84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/courselist/search.png
// module id = wjo4
// module chunks = 23